import React from 'react';
import Header from '../shared/Header';
import {Stat} from '../../types/stats';
import useTrans from '../../hooks/use-trans';

interface ResultHeaderInterface {
  stat: Stat;
}

const ResultHeader: React.FC<ResultHeaderInterface> = ({stat}) => {

  const trans = useTrans();

  const descriptions = (trans.pages.results.header.descriptions as string).replace(
    '[MODELNAME]',
    stat.model.modelName,
  );

  return (
    <Header
      title={trans.pages.results.header.title}
      descriptions={descriptions}
      image={stat.result?.image}
      imagePaddingLeft="2rem"
    />
  );
};

export default ResultHeader;
